export const CERTIFICATION_URL = {
  REISSUE: "/certificate/apis/unrestricted/token/reissue-with-cookie-domain",
}

export const USER = {
  INFO: "/user/apis/auth/info",
  INTEREST: `/user/apis/user/attribute/interest`,
  INQUIRY: `/user/apis/user/inquiry`,
  INQUIRY_HISTORY: (page: number) => `/user/apis/user/inquiry/${page}`,
  REVIEW_HISTORY: (page: number) => `/user/apis/user/review/${page}`,
  UNRESTRICTED_INQUIRY: "/user/apis/user/unrestricted/inquiry",
}

export const SIGN_IN_URL = {
  EMAIL: "/user/apis/auth/sign-in",
  SNS: "/user/apis/auth/sign-in/sns",
}

export const SIGN_UP_URL = "/user/apis/auth/sign-up"

export const ENTRY_FORM_URL = {
  SUBMIT: "/user/apis/user/unrestricted/store/application",
}
